var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NewHeader'),_c('div',{staticClass:"container mt-4 mb-5"},[_c('FullCalendar',{attrs:{"options":_vm.calendarOptions}})],1),_c('Footer'),_c('BackUp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }